import { Queries } from "@/components/features/queries/Queries";

export const QueriesRoute = ({
  context
}: {
  context: "company" | "client";
}) => <Queries context={context} />;
